import { hasRole } from 'utils/functions'
import session from '@/services/modules/session'

export const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: "dashboard-page" */'views/DashboardPage'),
    beforeEnter (to, from, next) {
      const hasDashboardAccess = hasRole('ui', 'UI_HOME_DASHBOARD')
      const hasReportAccess = hasRole('report', 'ROLE_GET_REPORT_COSTCENTER') ||
        hasRole('report', 'ROLE_GET_REPORT_TAXIJOBS') ||
        hasRole('report', 'ROLE_GET_REPORT_CHART') ||
        hasRole('report', 'ROLE_GET_REPORT_EMPLOYEE')
      const hasFinancialAccess = hasRole('billing', 'ROLE_GET_ORDER_PREVIEW_SUMMARY') &&
        hasRole('billing', 'ROLE_GET_ORDERS')

      if (!hasDashboardAccess && !hasReportAccess && !hasFinancialAccess) {
        return session.logout()
      }

      if (!hasDashboardAccess && !hasReportAccess && hasFinancialAccess) {
        return next({ name: 'InvoiceHistory' })
      }

      if (!hasDashboardAccess && hasReportAccess) {
        return next({ name: 'Reports' })
      }

      next()
    }
  }
]
